// ../styles/Services.js

import theme from '../theme/theme.js';

export const sectionStyles = {
  pt: 0,
  pb: 10,
  backgroundColor: 'background.default',
};

export const bannerWrapperStyles = {
  position: 'relative',
  mb: 4,
  py: 8,
  overflow: 'hidden',
  textAlign: 'center',
  color: '#fff',
  fontWeight: 900,
};

export const bannerImageStyles = {
  position: 'absolute',
  inset: 0,
  backgroundImage: `url(${process.env.PUBLIC_URL}/assets/service_banner.jpg)`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  filter: 'brightness(0.5)',
  zIndex: 1,
};

export const bannerTitleStyles = {
  position: 'relative',
  zIndex: 2,
  fontWeight: 700,
  fontSize: { xs: '2rem', sm: '3rem', md: '3.8rem' },
  lineHeight: 1.15,
  textShadow: '0 2px 10px rgba(0,0,0,0.4)',
};

export const chipContainerStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: 1.5,
  maxWidth: 900,
  mx: 'auto',
};

export const chipStyles = (isActive) => ({
  borderRadius: 8,
  fontWeight: 700,
  px: 2.5,
  py: 1,
  fontSize: {
    xs: '0.8rem',
    sm: '0.9rem',
    md: '1rem',
  },
  boxShadow: isActive ? theme.shadows[4] : 'none',
  transition: 'all 0.3s ease',
  whiteSpace: 'normal',
  textAlign: 'center',
  minWidth: { xs: 'auto', sm: 140 },
});

export const swiperWrapperStyles = {
  px: { xs: 1, md: 4 },
  py: 1,
};

export const cardStyles = (isMiddle) => ({
  width: '100%',
  maxWidth: 320,
  height: 400,
  display: 'flex',
  flexDirection: 'column',
  border: '1px solid',
  borderColor: 'primary.main',
  borderRadius: 2,
  overflow: 'hidden',
  backgroundColor: '#fff',
  boxShadow: isMiddle
    ? '0 5px 5px rgba(10,181,175,0.35)'
    : '0 5px 5px rgba(0,0,0,0.12)',
  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
});

export const cardHeaderStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  py: 3,
  px: 2,
  backgroundColor: 'white',
  height: 140,
};

export const iconBoxStyles = {
  backgroundColor: 'white',
  color: 'primary.contrastText',
  width: 64,
  height: 64,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  mb: 2,
};

export const iconImageStyles = {
  width: 40,
  height: 40,
};

export const cardTitleStyles = {
  fontWeight: 700,
  color: 'primary.main',
  lineHeight: 1.2,
  wordBreak: 'break-word',
  whiteSpace: 'normal',
};

export const cardContentStyles = {
  flexGrow: 1,
  px: 3,
  pt: 3,
  pb: 3,
  color: 'text.secondary',
  fontWeight: 400,
  fontSize: '1rem',
  lineHeight: 1.6,
  overflow: 'auto',
};

export const buttonWrapperStyles = {
  textAlign: 'center',
  mt: 8,
};
